// extracted by mini-css-extract-plugin
export default {"paginationSwiper":"IntractiveLearning_paginationSwiper__vwXmt","bullet":"IntractiveLearning_bullet__sxcLl","activeBullet":"IntractiveLearning_activeBullet__dc0WY"};